import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { selectAppName } from 'root-redux/selects/common'
import { selectUUID } from 'root-redux/selects/user'

import { eventLogger } from 'services/eventLogger.service'

import { APP_TERMS_OF_USE_LINKS, EVENT_SOURCE } from 'root-constants'

import { OuterLink } from '../OuterLink'

type TTermsOfUseLinkProps = {
  source: EVENT_SOURCE
  text?: string
}

export const TermsOfUseLink: React.FC<TTermsOfUseLinkProps> = ({
  source,
  text,
}) => {
  const userId = useSelector(selectUUID)
  const appName = useSelector(selectAppName)
  const { t } = useTranslation()

  return (
    <OuterLink
      href={APP_TERMS_OF_USE_LINKS[appName]}
      onClick={() => eventLogger.logTermsOfUseClicked(source, userId)}
    >
      {text || t('login.termsOfUse')}
    </OuterLink>
  )
}
